module.exports = __webpack_public_path__ + "img/img3.bb296768.jpg";